import React, { useState } from 'react';
import { TableList, Typography, DropdownMenu, TableListActions } from 'seagull';
import { Edit2Liner18, ProfileDeleteLiner18, MailSentLine18 } from 'seagull/icons';
import { Intent } from "../../infra/access-control";
import { MemberIdentifyingUnit } from "./components/MemberIdentifyingUnit";
import { testPrefix } from "./TeamPage.utils";
const changeRoleOfSoleOwnerTooltip = {
  placement: 'top',
  title: 'As the sole owner, your role cannot be changed'
};
const statusToColorCode = {
  Active: 'success',
  Pending: 'warning'
};
const statusToStatusName = {
  Active: 'Active',
  Pending: 'Pending invitation approval'
};
export default function MemberRow(props) {
  const {
    data,
    testid,
    adminOrMemberActingOnOwner,
    isEditingTheSoleOwner,
    isCurrentUser,
    onChangeRole,
    onResendInvitation,
    onRemoveFromTeam
  } = props;
  const [isResendingInvitation, setIsResendingInvitation] = useState(false);
  return /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": testid,
    key: data.user.id(),
    size: "large",
    items: [{
      value: /*#__PURE__*/React.createElement(MemberIdentifyingUnit, {
        user: data.user,
        testId: "".concat(testPrefix, "-identity")
      })
    }, {
      value: data.role,
      ['data-testid']: "".concat(testPrefix, "-role")
    }, {
      value: /*#__PURE__*/React.createElement(Typography, {
        skin: statusToColorCode[data.status],
        "data-testid": "".concat(testPrefix, "-status")
      }, statusToStatusName[data.status])
    }],
    actionColumn: /*#__PURE__*/React.createElement(TableListActions, {
      testId: "".concat(testPrefix, "-actions")
    }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      intent: Intent.ChangeRole,
      iconStart: /*#__PURE__*/React.createElement(Edit2Liner18, null),
      "data-testid": "".concat(testPrefix, "-change-role"),
      disabled: adminOrMemberActingOnOwner || isEditingTheSoleOwner,
      tooltipProps: isEditingTheSoleOwner ? changeRoleOfSoleOwnerTooltip : undefined,
      onClick: () => onChangeRole(data.user)
    }, "Change role"), data.user.isInvited() && /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      intent: Intent.ResendMemberInvitation,
      iconStart: /*#__PURE__*/React.createElement(MailSentLine18, null),
      "data-testid": "".concat(testPrefix, "-resend-invitation"),
      disabled: isResendingInvitation,
      onClick: async () => {
        setIsResendingInvitation(true);
        await onResendInvitation(data.user);
        setIsResendingInvitation(false);
      }
    }, "Resend invitation"), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      intent: Intent.RemoveFromTeam,
      skin: "error",
      iconStart: /*#__PURE__*/React.createElement(ProfileDeleteLiner18, null),
      "data-testid": "".concat(testPrefix, "-remove"),
      disabled: isCurrentUser || adminOrMemberActingOnOwner,
      onClick: () => onRemoveFromTeam(data.user)
    }, "Remove from team"))
  });
}